import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import React from 'react';
import SouthIcon from '@mui/icons-material/South';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'; 
import './progressCircle.css';
import { useNavigate, useLocation } from "react-router-dom"
import CircularProgressPercentage from './CircularProgressPercentage';
import testRunsPage from '../../containers/testRunsContainer';
import { APP_ROUTE_KEYS } from '../../shared/constants/constants';

const ProgressCircle = (props) => {
	const {
		iconType,
		circleIcon,
		sx,
		testCases,
		title = '',
		directionTitle = '',
		date,
		toDate,
		customerId,
		messageTypeId,
		paymentServiceId,
		count3,
		total,
		resultData,
		isdashboard,
		batchId,
		isbatchRun,
	} = props;
	const navigate = useNavigate();
  
	const properties={
		direction:directionTitle,
		result:'',
		triggerMessage:messageTypeId,
		startDate:date,
		endDate:toDate,
		isdashboard:isdashboard,
		batchId:batchId,
		isbatchRun:isbatchRun,
	}

	const handleTestcaseSelection = (status) => {
		properties.result=status;
        console.log(directionTitle);
		console.log(status);
		console.log(date);
		console.log(toDate);
		console.log(customerId);
		console.log(messageTypeId);
		console.log(paymentServiceId);
		console.log(properties);
		// testRunsPage(properties)
        // openModal()
		// navigate('/employee/Updateemployee', { state: { val } })
        navigate(`${APP_ROUTE_KEYS.TEST_RUNS.MASTER}/:testType`, { state: {properties}});
    };
	return (
		<Box sx={{ width: '100%', paddingLeft: '0px', paddingRight: '0px', marginTop: '10px' }}>
			<Card className="progress-circle">
				<Grid display="flex" sx={{ justifyContent: 'space-between', padding: '5px' }}>
					<Box sx={{ display: 'flex' }}>
						<Box
							sx={[
								{ width: '40px', height: '46px', display: 'flex', justifyContent: 'center' },
								{ ...sx },
							]}
						>
							{/* <SouthIcon sx={{color:"#1EA472",marginTop:'10px'}}/> */}
							{iconType}
						</Box>
						&nbsp;
						<Box>
							<Typography
								sx={{
									fontWeight: 700,
									fontSize: 16,
									display: 'flex',
									fontFamily: 'Inter',
									fontStyle: 'normal',
								}}
							>
								{directionTitle}
							</Typography>
							<Typography sx={{ display: 'flex', fontWeight: 400 }}>
								{total}&nbsp;
								{testCases && <span className="content-heading-executed">{title}</span>}
							</Typography>
						</Box>
					</Box>
					<Grid ml={0}>
						<span style={{ alignSelf: 'flex-end', display: 'flex' }}>{circleIcon}</span>
					</Grid>
				</Grid>
				<CardContent style={{ display: 'flex', justifyContent: 'space-between' }}>
					{resultData?.map((pEl, index) => (
						<Box key={index}>
							<Typography className="content-heading-executed">{pEl.resultTitle}</Typography>
							<Typography style={{ textAlign: 'center', fontWeight: 400 }}>{pEl.count}<ArrowDownwardIcon fontSize="small" style={{ marginLeft: 4, cursor: 'pointer' }}  onClick={() => handleTestcaseSelection(pEl.resultTitle)}/></Typography>
							 
						</Box>
					))}

					{/* <Box>
            <Typography className='content-heading-executed'>{resultTitle2}</Typography>
            <Typography style={{textAlign:"center",fontWeight:400}}>{count2}</Typography>
            </Box>
            <Box>
            <Typography className='content-heading-executed'>{resultTitle3}</Typography>
            <Typography style={{textAlign:"center",fontWeight:400}}>{count3}</Typography>
            </Box> */}
				</CardContent>
			</Card>
		</Box>
	);
};

export default ProgressCircle;
